var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999998 15.9476L0.999999 5C0.999999 2.79086 2.79086 1 5 1L32 1C34.2091 1 36 2.79086 36 5L36 15.9704C36 17.2427 35.3947 18.4392 34.3696 19.1929L20.9877 29.0328C19.5866 30.0631 17.6804 30.07 16.2719 29.0499L2.65376 19.1872C1.61501 18.4349 0.999997 17.2302 0.999998 15.9476Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999998 19.9476L0.999999 9C0.999999 6.79086 2.79086 5 5 5L32 5C34.2091 5 36 6.79086 36 9L36 19.9704C36 21.2427 35.3947 22.4392 34.3696 23.1929L20.9877 33.0328C19.5866 34.0631 17.6804 34.07 16.2719 33.0499L2.65376 23.1872C1.61501 22.4349 0.999997 21.2302 0.999998 19.9476Z",
    fill: "#FFCE67",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker2);
export default __webpack_public_path__ + "static/media/marker-2.4f36358a1622b4b94ce0aca8d35b79bf.svg";
export { ForwardRef as ReactComponent };